import { Typography } from 'seagull';
import { AnchorIcon } from 'seagull/icons';
import React from 'react';
import { QboIcon } from "../QboIcon";
import styles from "./MapServicesModal.module.scss";
export const columnDefs = [{
  width: 400
}, // Anchor service
{
  width: 400
}, // QuickBooks item names
{
  width: 260
} // Status
];
export const headerItems = [{
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(AnchorIcon, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "Anchor service name"))
}, {
  value: /*#__PURE__*/React.createElement("div", {
    className: styles.columnHeader
  }, /*#__PURE__*/React.createElement(QboIcon, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2"
  }, "QuickBooks Online service name"))
}, {
  value: 'Status'
}];